import { privateClient } from '../../../api/axios';

const getDocumentUrl = async (signatureRequestId) => privateClient.get(`/document/view/${signatureRequestId}`, {
  withCredentials: true,
  responseType: 'blob',
  headers: {
    Accept: 'application/pdf',
  },

});

export default getDocumentUrl;
